import { type TooltipModel, type Chart } from 'chart.js';

type ToolTipContext = {
  chart: Chart;
  tooltip: TooltipModel<'line'>;
};

const getOrCreateTooltip = () => {
  const tooltipContainer = document.getElementById('tooltip-container');
  let tooltipEl = document.getElementById('chartjs-tooltip');

  // Create and style element on first render
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = 'chartjs-tooltip';
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.border = '1px solid #EA0BBD';
    tooltipEl.style.borderRadius = '12px';
    tooltipEl.style.overflow = 'hidden';
    tooltipEl.style.backgroundColor = '#FFF';
    tooltipEl.style.fontFamily = 'Montserrat,sans-serif';
    tooltipEl.style.transform = 'translate(-50%, 10%)';
    tooltipEl.style.boxShadow = '0px 4px 4px 0px rgba(0, 0, 0, 0.25)';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.transition = 'all 200ms ease-out';

    const innerHTML = `
      <div style="display: flex; flex-direction: row; font-size: 16px; font-style: normal; font-weight: 700; line-height: normal; letter-spacing: 0.46px; font-family: Montserrat, sans-serif;">
        <div style="display: flex; flex-direction: column; gap: 4px; padding: 16px;">
          <div>Test Date</div>
          <div id="test-date" style="font-weight: 400; color: #6C7589;"></div>
        </div>
        <div style="
          padding: 16px;
          background: #EA0BBD;
          color: #FFF;
          font-size: 20px;
          text-align: center;
        ">
          <div id="percentile-rank" style="font-weight: 600;"></div>
          <div style="
            font-size: 12px;
            font-weight: 600;
          ">
            Percentile
          </div>
        </div>
        </div>
    `;

    tooltipEl.innerHTML = innerHTML;
    tooltipContainer?.appendChild(tooltipEl);
  }

  return tooltipEl;
};

export const externalTooltipHandler = (context: ToolTipContext) => {
  const { tooltip, chart } = context;
  const tooltipEl = getOrCreateTooltip();
  const bodyLines = tooltip.body?.[0]?.lines ?? [];

  // Hide if no tooltip
  if (tooltip.opacity == 0 || !bodyLines?.length) {
    tooltipEl.style.opacity = '0';
    return;
  }

  // Set the tooltip content
  if (bodyLines.length) {
    const percentileRankEl = document.getElementById('percentile-rank');
    const testDateEl = document.getElementById('test-date');

    const percentileRank = bodyLines?.[0];
    const testDate = bodyLines?.[1];

    if (percentileRankEl && percentileRank) {
      percentileRankEl.textContent = percentileRank;
    }

    if (testDateEl && testDate) {
      testDateEl.innerText = testDate;
    }
  }

  // Display and position the tooltip
  const position = chart.canvas.getBoundingClientRect();
  tooltipEl.style.opacity = '1';
  tooltipEl.style.left = position.left + window.scrollX + tooltip.caretX + 'px';
  tooltipEl.style.top = position.top + window.scrollY + tooltip.caretY + 'px';
};
